import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Style
import './index.scss'

// Actions
import {
  createDracarRepairOrder,
  useDracarRepairOrder,
  searchDracarCustomer,
  searchDracarCompany,
  searchDracarCustomerCompany,
  searchDracarVehicle,
  checkForDracarVehicle,
  validateOrder,
  validateDracarCustomer,
  validateDracarVehicle,
  getDracarRepairOrder
} from '../../../actions/dracar'
import { getOrder, getOrderVehicleData } from '../../../actions/orders'
import { getListSimple } from '../../../actions/spareparts'

// Functions
import { translation } from '../../../utils/helpers'

// Elements
import { MainMenuIcons } from '../../elements/icons'
import Modal from '../../components/Modal'
import TabBar from '../../elements/tabBar'
import TabItem from '../../elements/tabItem'
import Row from '../../elements/row'
import Col from '../../elements/col'
// import PanelHeader from '../../elements/panelHeader'
import Text from '../../elements/text'
import Divider from '../../elements/divider'
import Radio from '../../elements/radio'
import Button from '../../elements/button'
import LabelWrapper from '../../elements/labelWrapper'
import Grid from '../../elements/grid'
import Label from '../../elements/label'
import OrangeDivider from '../../elements/orangeDivider'
import DropDown from '../../elements/dropDown'
// import Inline from '../../elements/inline'

const CustomerType = {
  company: 0,
  customer: 1
}

class DracarModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      step: 1,
      showSpinner: false,
      showSearchSpinner: false,
      showButtonSpinner: false,
      showCreateOrderButton: false,
      overflowHidden: false,

      stepOneValid: false,
      stepTwoValid: false,

      createNewRepairOrder: true,
      repairOrderId: '',

      dracar: {
        orderId: this.props.order.Id,
        sparePartSupplier: 0,
        customerId: '0',
        isInsuranceType: false,
        isCustomerType: false,
        isCompanyType: false,
        customerType: 0,
        isCompany: false,
        givenName: '',
        familyName: '',
        phone: '',
        email: '',
        licensePlate: this.props.order.RegNumber ? this.props.order.RegNumber : '',
        vin: this.props.order.ChassisNumber ? this.props.order.ChassisNumber : '',
        brandNameId: this.props.order.BrandName ? this.props.order.BrandName.Id : 0,
        brandName: this.props.order.BrandName ? this.props.order.BrandName.Name : '',
        model: this.props.order.Model ? this.props.Model : '',
        modelYear: 0
      },

      sparePartSuppliers: [],
      searchGivenName: '',
      searchFamilyName: '',
      searchPhone: this.props.order ? this.props.order.CarOwnerPhone ? this.props.order.CarOwnerPhone : '' : '',
      searchEmail: this.props.order ? this.props.order.CarOwnerMail ? this.props.order.CarOwnerMail : '' : '',

      selectedSuggested: false,
      customerTypeChecked: true,
      customerSuggestions: [],
      disableCustomerInput: false,
      disableLicensePlateInput: false,

      insuranceIndracarMatchedCompanyType: 0,
      hasInsuranceDebtorInDracar: false,
      vehicleExist: false,
      foundVehicle: null,
      invalidOrder: false,
      handledFirstTimeLicensePlateSearch: false
    }

    this.handleOnChangeLicensePlate = this.handleOnChangeLicensePlate.bind(this)
    this.handleOnSearchChange = this.handleOnSearchChange.bind(this)
    this.handleOnChangeCustomerType = this.handleOnChangeCustomerType.bind(this)
    this.handleSuggestedCustomer = this.handleSuggestedCustomer.bind(this)
    this.handleSelectRecipientInvoice = this.handleSelectRecipientInvoice.bind(this)
    this.handleOnChangeCreateNewRepairOrder = this.handleOnChangeCreateNewRepairOrder.bind(this)
    this.handleSearchForSuggestedCustomer = this.handleSearchForSuggestedCustomer.bind(this)
    this.handleSearchForVehicle = this.handleSearchForVehicle.bind(this)
    this.handleRefreshCustomerSuggestions = this.handleRefreshCustomerSuggestions.bind(this)
    this.handleValidation = this.handleValidation.bind(this)
    this.getDracarRepairOrder = this.getDracarRepairOrder.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.hasSelectedCustomerState = this.hasSelectedCustomerState.bind(this)
    this.getDefaultDracarClientState = this.getDefaultDracarClientState.bind(this)
    this.onSupplierChange = this.onSupplierChange.bind(this)
    this.resetState = this.resetState.bind(this)
    this.getSparePartSuppliers = this.getSparePartSuppliers.bind(this)
    this.onChange = this.onChange.bind(this)
    this.getKeyLoopSystemName = this.getKeyLoopSystemName.bind(this)
    this.getRepairOrderAlias = this.getRepairOrderAlias.bind(this)
  }

  componentDidMount () {
    if (this.props.order) {
      this.getSparePartSuppliers()
    }
  }

  resetState () {
    this.setState({
      ...this.state,
      dracar: {
        ...this.state.dracar,
        customerId: '0',
        isInsuranceType: false,
        isCustomerType: false,
        isCompanyType: false,
        isCompany: false,
        givenName: '',
        familyName: '',
        phone: '',
        email: '',
        licensePlate: this.props.order.RegNumber ? this.props.order.RegNumber : '',
        vin: this.props.order.ChassisNumber ? this.props.order.ChassisNumber : '',
        brandNameId: this.props.order.BrandName ? this.props.order.BrandName.Id : 0,
        brandName: this.props.order.BrandName ? this.props.order.BrandName.Name : '',
        model: this.props.order.Model ? this.props.Model : '',
        modelYear: 0
      },
      searchGivenName: '',
      searchFamilyName: '',
      searchPhone: this.props.order ? this.props.order.CarOwnerPhone ? this.props.order.CarOwnerPhone : '' : '',
      searchEmail: this.props.order ? this.props.order.CarOwnerMail ? this.props.order.CarOwnerMail : '' : '',
      selectedSuggested: false,
      customerTypeChecked: true,
      customerSuggestions: [],
      disableCustomerInput: false
    })
  }

  onChange (e) {
    let value = e.target.value
    this.setState({
      [e.target.name]: value
    })
  }

  getSparePartSuppliers () {
    this.props.getListSimple(true).then(res => {
      this.setState({
        sparePartSuppliers: res.data
      })
    })
  }

  getDefaultDracarClientState () {
    return {
      customerId: '0',
      givenName: '',
      familyName: '',
      phone: '',
      email: ''
    }
  }

  hasSelectedCustomerState () {
    const { dracar, vehicleExist, selectedSuggested } = this.state

    if (!vehicleExist && dracar.customerId === '0' || dracar.customerId === null || !selectedSuggested) {
      return true
    } else {
      return false
    }
  }

  handleErrors (err) {
    if (err) {
      if (err.response) {
        if (err.response.data !== undefined && err.response.data !== null && Array.isArray(err.response.data) && err.response.data.length > 0) {
          let errors = err.response.data
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        } else {
          window.toastr.error(translation('910'), translation('216'))
        }
      } else {
        window.toastr.error(err, translation('216'))
      }
    }
  }

  onSupplierChange (e) {
    let value = typeof e.target.value !== 'number' ? parseInt(e.target.value) : e.target.value
    let reset = this.state.dracar.sparePartSupplier !== 0 && this.state.dracar.sparePartSupplier !== value
    this.setState({
      dracar: {
        ...this.state.dracar,
        sparePartSupplier: value
      }
    }, () => {
      if (reset) {
        this.resetState()
      }
      this.handleSearchForVehicle(null, false, false)
    })
  }

  handleOnSearchChange (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleOnChangeLicensePlate (e) {
    const { dracar, foundVehicle, vehicleExist } = this.state
    const noLicensePlateInput = e.target.value ? e.target.value.length === 0 : true

    this.setState({
      dracar: {
        ...dracar,
        [e.target.name]: e.target.value
      },
      foundVehicle: noLicensePlateInput ? null : foundVehicle,
      vehicleExist: noLicensePlateInput ? false : vehicleExist,
      showCreateOrderButton: noLicensePlateInput
    })
  }

  handleOnChangeCustomerType (e, value) {
    const { dracar } = this.state
    this.setState({
      dracar: {
        ...dracar,
        ...this.getDefaultDracarClientState(),
        [e.target.name]: value
      },
      customerSuggestions: [],
      customerTypeChecked: true,
      selectedSuggested: false
    })
  }

  handleOnChangeCreateNewRepairOrder (e, value) {
    this.setState({
      createNewRepairOrder: value
    })
  }

  handleSuggestedCustomer (radioName, item) {
    const { dracar } = this.state
    const itemId = item.companyId || item.customerId
    this.setState({
      dracar: {
        ...dracar,
        customerId: itemId,
        givenName: `${item.givenName}`,
        familyName: `${item.familyName}`,
        isCompany: item.isCompany,
        phone: item.phone,
        email: item.email
      },
      selectedSuggested: true
    })
  }

  handleSelectRecipientInvoice (e) {
    const { dracar } = this.state
    let isCustomerType = dracar.isCustomerType
    let isCompanyType = dracar.isCompanyType
    let customerType = dracar.customerType
    let isInsuranceType = dracar.isInsuranceType
    let disableCustomerInput = this.state.disableCustomerInput
    let selectedSuggested = false
    let customerSuggestions = []

    if (e.target.name === 'isCompanyType') {
      isCustomerType = false
      customerType = CustomerType.company
      isInsuranceType = false
      disableCustomerInput = false
      customerSuggestions = []
    } else if (e.target.name === 'isCustomerType') {
      isCompanyType = false
      customerType = CustomerType.customer
      isInsuranceType = false
      disableCustomerInput = false
      customerSuggestions = []
    } else if (e.target.name === 'isInsuranceType') {
      isCompanyType = false
      isCustomerType = false
      customerType = this.state.insuranceIndracarMatchedCompanyType
      disableCustomerInput = true
      selectedSuggested = true
    }

    this.setState({
      dracar: {
        ...dracar,
        customerId: '0',
        isCustomerType,
        isCompanyType,
        isInsuranceType,
        isCompany: isCompanyType,
        customerType,
        [e.target.name]: e.target.value
      },
      customerSuggestions,
      selectedSuggested,
      disableCustomerInput
    })
  }

  handleSearchForSuggestedCustomer (e, search = true) {
    if (!search) return

    const dracar = {
      IsCompany: this.state.dracar.isCompany,
      GivenName: this.state.searchGivenName,
      FamilyName: this.state.searchFamilyName,
      Phone: this.state.searchPhone,
      Email: this.state.searchEmail,
      sparePartSupplier: this.state.dracar.sparePartSupplier,
      customerType: this.state.customerType
    }

    this.setState({ showSearchSpinner: true }, () => {
      if (this.state.dracar.isCompanyType || this.state.dracar.isCustomerType) {
        if (this.state.dracar.isCompany || this.state.dracar.isCompanyType) {
          this.props.searchDracarCompany(dracar)
          .then(res => {
            this.handleRefreshCustomerSuggestions(false, res.data)
          })
          .catch(err => {
            this.handleRefreshCustomerSuggestions(false, [])
            this.handleErrors(err)
          })
        } else {
          this.props.searchDracarCustomer(dracar)
          .then(res => {
            this.handleRefreshCustomerSuggestions(false, res.data)
          })
          .catch(err => {
            this.handleRefreshCustomerSuggestions(false, [])
            this.handleErrors(err)
          })
        }
      } else this.handleRefreshCustomerSuggestions(false, [])
    })
  }

  handleRefreshCustomerSuggestions (spinnerValue, data) {
    let suggestions = []
    if (Array.isArray(data)) {
      suggestions = data
    }

    this.setState({ showSearchSpinner: spinnerValue, customerSuggestions: suggestions, hasInsuranceDebtorInDracar: false })
  }
  handleSearchForVehicle (e, showErrors = true, showSpinner = true) {
    const { dracar } = this.state

    this.setState({ showSearchSpinner: showSpinner, disableLicensePlateInput: true }, () => {
      this.props.getOrderVehicleData(dracar.licensePlate, 'RegNumber')
      .then(vehicleRes => {
        if (vehicleRes.data.Success) {
          this.props.checkForDracarVehicle({ LicensePlate: dracar.licensePlate, sparePartSupplier: dracar.sparePartSupplier, OrderId: dracar.orderId })
          .then(res => {
            const updateObj = {
              vehicleExist: res.data.VehicleExist,
              hasInsuranceDebtorInDracar: res.data.HasInsuranceDebtorInDracar,
              foundVehicle: res.data.DracarVehicleInfo,
              showSearchSpinner: false,
              disableLicensePlateInput: false,
              disableCustomerInput: res.data.HasInsuranceDebtorInDracar,
              selectedSuggested: true,
              insuranceIndracarMatchedCompanyType: res.data.IsCompany ? CustomerType.company : CustomerType.customer,
              dracar: {
                ...dracar,
                vin: vehicleRes.data.ChassisNumber,
                brandNameId: vehicleRes.data.BrandNameId,
                brandName: vehicleRes.data.BrandName,
                model: vehicleRes.data.Model,
                customerId: res.data.Id,
                givenName: res.data.GivenName,
                familyName: res.data.FamilyName,
                phone: res.data.Phone,
                email: res.data.Email,
                isCompany: res.data.IsCompany,
                isInsuranceType: res.data.HasInsuranceDebtorInDracar
              },
              handledFirstTimeLicensePlateSearch: true,
              showCreateOrderButton: true
            }
            this.setState({ ...updateObj })
          })
          .catch(err => {
            if (showErrors) this.handleErrors(err)
            this.setState({ showSearchSpinner: false, disableLicensePlateInput: false })
          })
        } else {
          if (showErrors) window.toastr.error(translation('16631'), translation('216'))
          this.setState({ showSearchSpinner: false, disableLicensePlateInput: false })
        }
      })
      .catch(() => {
        if (showErrors) window.toastr.error(translation('16631'), translation('216'))
        this.setState({
          dracar: {
            ...dracar,
            licensePlate: ''
          },
          showSearchSpinner: false,
          disableLicensePlateInput: false
        })
      })
    })
  }

  getDracarRepairOrder () {
    var getRepairOrderData = {
      RepairOrderId: this.state.repairOrderId,
      OrderId: this.state.dracar.orderId,
      SparePartSupplierId: this.state.dracar.sparePartSupplier
    }
    this.props.getDracarRepairOrder(getRepairOrderData).then((res) => {
      this.props.onSuccess(res.data)
    }, (err) => {
      console.log('error', err.data)
      this.handleErrors(err)
    })
  }

  handleValidation (step) {
    let { dracar, showButtonSpinner, selectedSuggested, hasInsuranceDebtorInDracar } = this.state
    if (showButtonSpinner) return

    if (step === 1) {
      this.setState({ step })
    } else if (step === 2) {
      if (dracar.sparePartSupplier !== 0) {
        this.setState({ step })
      }
    } else if (step === 3) {
      if (this.hasSelectedCustomerState()) return
      this.setState({ disableCustomerInput: true, showButtonSpinner: true }, () => {
        this.props.validateDracarCustomer(dracar)
          .then(res => {
            this.setState({ step, showButtonSpinner: false, disableCustomerInput: hasInsuranceDebtorInDracar || false })
          })
          .catch(err => {
            this.setState({ showButtonSpinner: false, disableCustomerInput: false }, () => {
              this.handleErrors(err)
            })
          })
      })
    } else if (step === 4) {
      if (this.hasSelectedCustomerState()) return
      const spinnersOff = { showSpinner: false, showButtonSpinner: false, disableLicensePlateInput: false }

      this.setState({ showButtonSpinner: true, disableLicensePlateInput: true }, () => {
        this.props.validateDracarVehicle(dracar)
        .then(res => {
          this.setState({ showSpinner: true, showButtonSpinner: false, disableLicensePlateInput: false }, () => {
            this.props.createDracarRepairOrder(dracar)
            .then(dracarRes => {
              this.props.getOrder(this.props.order.Id).then(res => {
                this.setState({ ...spinnersOff }, () => {
                  this.props.onSuccess(dracarRes.data)
                })
              })
              .catch(err => {
                this.handleErrors(err)
                this.setState({ ...spinnersOff })
              })
            })
            .catch(err => {
              this.handleErrors(err)
              let stateObj = { ...spinnersOff, dracar: { ...dracar }, selectedSuggested }
              let search = false

              // In the case of successfully getting to the create repair order part, and the order
              // creation fails, we have by that point, most likely created a customer and vehicle,
              // thus, we search for the customer, mark them as a suggested and ensure we do not
              // create duplicates
              if (err.response) {
                const data = err.response.data
                if (data && (typeof data) === 'object') {
                  if ('Email' in data && 'FamilyName' in data && 'GivenName' in data && 'Phone' in data) {
                    Object.keys(data).map(key => {
                      const camelKey = key.charAt(0).toLowerCase() + key.substring(1)
                      stateObj.dracar[camelKey] = data[key]
                    })
                    stateObj.selectedSuggested = true
                    stateObj['searchEmail'] = data['Email']
                    stateObj['searchFamilyName'] = data['FamilyName']
                    stateObj['searchGivenName'] = data['GivenName']
                    stateObj['searchPhone'] = data['Phone']
                    search = true
                  }
                }
              }

              this.setState({ ...stateObj }, () => {
                this.handleSearchForSuggestedCustomer(null, search)
              })
            })
          })
        })
        .catch(err => {
          this.setState({ ...spinnersOff }, () => {
            this.handleErrors(err)
          })
        })
      })
    }
  }

  getKeyLoopSystemName () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(15352)
      case 6: return translation(18138)
    }
    return ''
  }

  getRepairOrderAlias () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(18149)
      case 6: return translation(18150)
    }
    return ''
  }

  renderMatchedCustomers () {
    const { dracar, customerSuggestions, showSearchSpinner, hasInsuranceDebtorInDracar } = this.state

    if (showSearchSpinner) return this.renderSpinner()

    const renderLabel = (item) => {
      let label = ''
      if (item.givenName) {
        label += `${item.givenName} `
      }
      if (item.familyName) {
        label += `${item.familyName}`
      }
      if (item.phone) {
        label += `\n${item.phone}`
      }
      if (item.email) {
        label += `\n${item.email}`
      }
      if (item.companyId) {
        label += `\n${item.companyId}`
      }
      if (label === '') {
        label += translation('16594')
      }

      return label
    }

    let content = <Label>{translation('16594')}</Label>
    if (customerSuggestions.length > 0) {
      content = customerSuggestions.map((item, index) => {
        const radioName = `customerSuggestion-${index}`
        let itemId = item.customerId !== undefined ? item.customerId : item.companyId
        return (
          <Radio key={`suggestion-${index}`}
            name={radioName}
            onChange={e => this.handleSuggestedCustomer(radioName, item)}
            checked={itemId === dracar.customerId}
            labelText={renderLabel(item)}
          />
        )
      })
    } else if (hasInsuranceDebtorInDracar) {
      return (
        renderLabel(dracar)
      )
    }

    return (
      <div className={dracar.isCompany ? 'dracarModal__customers' : 'dracarModal__customers__private'}>
        {content}
      </div>
    )
  }

  renderSpinner () {
    return (
      <Grid cols={['min-content', 1, 'max-content']} align='center'>
        <div className='divider' key='1' />
        <div className='dracarModal__spinner' key='2'>
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        </div>
      </Grid>
    )
  }

  renderHeader (step) {
    if (this.state.showSpinner) return this.renderSpinner()

    return (
      <div className='dracarModal__header'>
        <TabBar>
          <TabItem><Link className={step === 1 ? 'active' : ''} onClick={e => this.handleValidation(1)}>{translation('16765')}</Link></TabItem>
          { this.state.createNewRepairOrder && [
            <TabItem><Link className={step === 2 ? 'active' : ''} onClick={e => this.handleValidation(2)}>{translation('58')}</Link></TabItem>,
            <TabItem><Link className={step === 3 ? 'active' : ''} onClick={e => this.handleValidation(3)}>{translation('16587')}</Link></TabItem>
          ]}
        </TabBar>
      </div>
    )
  }

  renderStepOne () {
    const { sparePartSuppliers, dracar, createNewRepairOrder } = this.state
    const supplier = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Name}</option>
      )
    }
    return (
      <div className='dracarModal__suppliers'>
        <Row>
          <Col>
            <Label>{translation('16766')}</Label>
            <DropDown name='sparePartSupplier' value={dracar.sparePartSupplier} onChange={this.onSupplierChange} labelText={translation('16767')}>
              <option value='0'>{translation('16768')}</option>
              {sparePartSuppliers.map(supplier)}
            </DropDown>
            <Divider noLine />
            <Radio
              name='createNewRepairOrder'
              onChange={e => this.handleOnChangeCreateNewRepairOrder(e, true)}
              checked={createNewRepairOrder}
              labelText={translation('16816').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias())}
            />
            <Radio
              name='createNewRepairOrder'
              onChange={e => this.handleOnChangeCreateNewRepairOrder(e, false)}
              checked={!createNewRepairOrder}
              labelText={translation('16817').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()).replace('[RepairOrderAlias]', this.getRepairOrderAlias())}
            />
            {!createNewRepairOrder && [
              <Text labelText={translation('16820').replace('[RepairOrderAlias]', this.getRepairOrderAlias())} name='repairOrderId' onChange={this.onChange.bind(this)} value={this.state.repairOrderId} />
            ]}
          </Col>
        </Row>
      </div>
    )
  }

  renderStepTwo () {
    const {
      dracar,
      selectedSuggested,
      disableCustomerInput,
      customerTypeChecked,
      searchGivenName,
      searchFamilyName,
      searchPhone,
      searchEmail,
      vehicleExist,
      hasInsuranceDebtorInDracar
    } = this.state

    let searchButtonStyle = 'primary'
    if (selectedSuggested) searchButtonStyle = 'link'

    return (
      <div>
        {vehicleExist && <Row>
          <Col>
            <div className='dracarModal__col'>
              <LabelWrapper labelText={translation('58')}>
                <Divider noLine />
                {/* DO NOT DELETE THE FOLLOWING COMMENTED CODE */}
                {/* <Inline>
                  <Radio
                    name='isCompany'
                    onChange={e => this.handleOnChangeCustomerType(e, false)}
                    checked={!dracar.isCompany && customerTypeChecked}
                    labelText={translation('782')}
                    disabled={disableCustomerInput}
                    />
                  <Radio
                    name='isCompany'
                    onChange={e => this.handleOnChangeCustomerType(e, true)}
                    checked={dracar.isCompany && customerTypeChecked}
                    labelText={translation('35')}
                    disabled={disableCustomerInput}
                  />
                </Inline> */}
                {!customerTypeChecked ? null : (
                  <Text
                    labelText={dracar.isCompany || dracar.isCompanyType ? translation('30') : translation('16606')}
                    name='searchGivenName'
                    onChange={this.handleOnSearchChange}
                    value={searchGivenName}
                    disabled={disableCustomerInput}
                  />
                )}
                {!customerTypeChecked ? null : (
                  dracar.isCompany || dracar.customerType === CustomerType.company ? null : (
                    <Text
                      labelText={translation('16607')}
                      name='searchFamilyName'
                      onChange={this.handleOnSearchChange}
                      value={searchFamilyName}
                      disabled={disableCustomerInput}
                    />
                  )
                )}
                <Text labelText={translation('31')} name='searchPhone' onChange={this.handleOnSearchChange} value={searchPhone} disabled={disableCustomerInput} />
                <Text labelText={translation('1052')} name='searchEmail' onChange={this.handleOnSearchChange} value={searchEmail} disabled={disableCustomerInput} />
                <Button style={searchButtonStyle} spacing='0' size='l' onClick={this.handleSearchForSuggestedCustomer} labelText={translation('16625')} disabled={disableCustomerInput} />
              </LabelWrapper>
            </div>
          </Col>
          <Col>
            <LabelWrapper labelText={translation('16763').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())}>
              <Divider noLine />
              {this.props.auth.accountingSystem === 4 && <Radio
                name='isInsuranceType'
                onChange={e => this.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } })}
                checked={dracar.isInsuranceType}
                labelText={translation('418')}
                disabled={!hasInsuranceDebtorInDracar}
              />}
              <Radio
                name='isCustomerType'
                onChange={e => this.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } })}
                checked={dracar.isCustomerType}
                labelText={translation('14893')}
              />
              <Radio
                name='isCompanyType'
                onChange={e => this.handleSelectRecipientInvoice({ target: { name: e.target.name, value: e.target.checked } })}
                checked={dracar.isCompanyType}
                labelText={translation('65')}
              />
              <OrangeDivider size={2} />
              <LabelWrapper labelText={translation('16590')}>
                {this.renderMatchedCustomers()}
              </LabelWrapper>
            </LabelWrapper>
          </Col>
        </Row>}
        {!vehicleExist && <Row>
          <Col>
            <LabelWrapper labelText={translation('17951').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())}>
              {translation('17952').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())}
            </LabelWrapper>
          </Col>
        </Row>}
      </div>
    )
  }

  renderStepThree () {
    const { dracar, vehicleExist, disableLicensePlateInput, showSearchSpinner, handledFirstTimeLicensePlateSearch, showCreateOrderButton } = this.state

    const hasLicensePlateFilled = dracar.licensePlate.replace(/\s/g, '').length > 0
    const searchButtonStyle = handledFirstTimeLicensePlateSearch && hasLicensePlateFilled && showCreateOrderButton ? 'link' : 'primary'

    return (
      <div>
        <Row>
          <Col>
            <LabelWrapper labelText={translation('16587')}>
              <Divider noLine />
              <Text labelText={translation('78')}
                name='licensePlate'
                onChange={this.handleOnChangeLicensePlate}
                value={dracar.licensePlate}
                disabled={disableLicensePlateInput}
                placeholder={translation('16498')}
              />
              {this.renderVehicleInfo()}
              {vehicleExist ? null : <Button style={searchButtonStyle} spacing='0' size='l' onClick={this.handleSearchForVehicle.bind(this)} labelText={translation('16635')} disabled={showSearchSpinner} />}
            </LabelWrapper>
          </Col>
          <Col>
            <LabelWrapper labelText={translation('16588')}>
              <Divider noLine />
              {showSearchSpinner ? this.renderSpinner() : (
                <Label>
                  {vehicleExist ? translation('16592').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()) : !handledFirstTimeLicensePlateSearch || !hasLicensePlateFilled || !showCreateOrderButton ? '' : translation('16634')}
                </Label>
              )}
            </LabelWrapper>
          </Col>
        </Row>
      </div>
    )
  }

  renderVehicleInfo () {
    const { vehicleExist, foundVehicle } = this.state
    if (!vehicleExist || !foundVehicle) return null

    return (
      <Label>
        {`${foundVehicle.make} ${foundVehicle.model} ${foundVehicle.modelYear}\n${foundVehicle.vin}`}
      </Label>
    )
  }

  render () {
    const {
      dracar,
      step,
      showSpinner,
      showButtonSpinner,
      customerTypeChecked,
      selectedSuggested,
      invalidOrder,
      vehicleExist,
      hasInsuranceDebtorInDracar,
      disableCustomerInput
    } = this.state

    let nextButtonDisabled = (((showButtonSpinner || this.hasSelectedCustomerState() || !customerTypeChecked) && selectedSuggested) || invalidOrder)
    const hasLicensePlateFilled = dracar.licensePlate.replace(/\s/g, '').length > 0

    if (!hasInsuranceDebtorInDracar) {
      if (!dracar.isCustomerType && !dracar.isCompanyType) nextButtonDisabled = true
      else nextButtonDisabled = !selectedSuggested
    } else nextButtonDisabled = false

    if ((dracar.isCustomerType || dracar.isCompanyType) && !selectedSuggested && !disableCustomerInput) nextButtonDisabled = true

    let renderView = () => null
    let bottomBarProps = null
    let className = 'dracarModal'
    let hiddeButton = ' disabled-action-label'

    switch (step) {
      case 1:
      default:
        let stepOneAction = this.handleValidation.bind(this, 2)
        if (!this.state.createNewRepairOrder) {
          stepOneAction = this.getDracarRepairOrder.bind(this)
        }
        if (dracar.sparePartSupplier === 0) className += hiddeButton
        renderView = () => this.renderStepOne()
        bottomBarProps = {
          actionLabelText: translation('237'),
          onActionClick: stepOneAction,
          cancelLabelText: translation('1155'),
          onCancelClick: () => this.props.handleToggle(),
          center: true
        }
        break
      case 2:
        if (nextButtonDisabled) className += hiddeButton
        renderView = () => this.renderStepTwo()
        bottomBarProps = {
          actionLabelText: translation('237'),
          onActionClick: () => this.handleValidation(3),
          cancelLabelText: translation('1155'),
          onCancelClick: () => this.props.handleToggle(),
          center: true
        }
        break
      case 3:
        if (!hasLicensePlateFilled || !vehicleExist || showSpinner) className += hiddeButton
        renderView = () => this.renderStepThree()
        bottomBarProps = {
          actionLabelText: translation('16589').replace('[KeyLoopSystem]', this.getKeyLoopSystemName()),
          onActionClick: () => this.handleValidation(4),
          cancelLabelText: translation('1155'),
          onCancelClick: () => this.props.handleToggle(),
          center: true
        }
        break
    }

    return (
      <div className={className}>
        <Modal
          {...this.props}
          header={translation('16591').replace('[KeyLoopSystem]', this.getKeyLoopSystemName())}
          overflowHidden={this.state.overflowHidden}
          icon={MainMenuIcons.Forsi_White}
          bottomBarProps={showSpinner ? null : bottomBarProps}
        >
          {this.renderHeader(step)}
          <div>
            {!showSpinner && renderView()}
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  createDracarRepairOrder,
  useDracarRepairOrder,
  searchDracarCustomer,
  searchDracarCompany,
  searchDracarCustomerCompany,
  searchDracarVehicle,
  checkForDracarVehicle,
  validateOrder,
  validateDracarCustomer,
  validateDracarVehicle,
  getDracarRepairOrder,
  getOrder,
  getOrderVehicleData,
  getListSimple
})(DracarModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/DracarModal/index.js